/**
 * Loop Custom Subscription Widget - JavaScript
 * Upload this file to Loop app > Widget Design > Custom Widget > Assets
 * Integrates with Loop Subscriptions and native Shopify ATC button
 * Includes price breaks support for one-time purchases
 * Version: 2024-10-31-CART-MERGE-FIX
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLoopCustomWidget);
  } else {
    initLoopCustomWidget();
  }

  function initLoopCustomWidget() {
    const widget = document.querySelector('.loop-custom-widget-container');
    if (!widget) return;

    const productId = widget.getAttribute('data-product-id');
    const purchaseTypeRadios = widget.querySelectorAll('input[name^="loop-custom-purchase-type"]');
    const frequencyRadios = widget.querySelectorAll('input[name^="loop-custom-frequency"]');
    const scheduleSection = widget.querySelector('.loop-custom-schedule-section');
    const priceBreaksSection = widget.querySelector('.loop-custom-price-breaks-section');
    const priceBreakRadios = widget.querySelectorAll('.loop-custom-price-break-radio');

    // Find native Shopify ATC button - search for the form with matching product ID
    let shopifyAtcButton = null;
    let productForm = null;

    console.log('>>> LOOKING FOR PRODUCT ID:', productId);

    // Find all product forms on the page
    const allForms = document.querySelectorAll('form[action*="/cart/add"]');
    console.log('>>> FOUND', allForms.length, 'PRODUCT FORMS ON PAGE');

    // Find the form that has a variant ID input for this product
    for (const form of allForms) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) {
        console.log('>>> CHECKING FORM WITH VARIANT INPUT:', variantInput.value);

        // Find the ATC button in this form
        const button = form.querySelector('button[type="submit"], button[name="add"]');
        if (button) {
          // Check if this form is for the main product (not complementary/bundle)
          // Main product forms are typically the first form or the one with buy-buttons class
          const buyButtonsContainer = button.closest('buy-buttons, .buy-buttons, [data-block-type="buy-buttons"]');
          if (buyButtonsContainer) {
            console.log('>>> FOUND MAIN PRODUCT FORM WITH BUY-BUTTONS');
            productForm = form;
            shopifyAtcButton = button;
            break;
          }
        }
      }
    }

    // Fallback: use first form if no buy-buttons found
    if (!shopifyAtcButton && allForms.length > 0) {
      console.log('>>> FALLBACK: Using first product form');
      productForm = allForms[0];
      shopifyAtcButton = productForm.querySelector('button[type="submit"], button[name="add"]');
    }

    if (shopifyAtcButton) {
      console.log('>>> FOUND ATC BUTTON:', shopifyAtcButton.textContent.substring(0, 50));
    } else {
      console.log('>>> ERROR: Could not find ATC button');
    }

    // Find Loop's hidden selling_plan input within the same form
    let loopSellingPlanInput = null;
    if (productForm) {
      loopSellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
    }
    if (!loopSellingPlanInput) {
      loopSellingPlanInput = document.getElementById('loop-selling-plan-input') || document.querySelector('input[name="selling_plan"]');
    }

    // Get product data
    const basePrice = parseFloat(widget.getAttribute('data-base-price')) || 0;

    // Handle purchase type change
    purchaseTypeRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        const isSubscribe = this.value === 'subscribe';

        // Update selected state visually for purchase type
        widget.querySelectorAll('.loop-custom-type-option').forEach(option => {
          option.classList.remove('is-selected');
        });
        this.closest('.loop-custom-type-option').classList.add('is-selected');

        // Toggle widget state
        if (isSubscribe) {
          widget.classList.remove('is-onetime');
        } else {
          widget.classList.add('is-onetime');
        }

        // Update Shopify button and Loop input
        updateShopifyButton();
      });
    });

    // Handle frequency/servings change
    frequencyRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        // Update selected state visually
        widget.querySelectorAll('.loop-custom-frequency-option').forEach(option => {
          option.classList.remove('is-selected');
        });
        this.closest('.loop-custom-frequency-option').classList.add('is-selected');

        // Update Shopify button and Loop input
        updateShopifyButton();
      });
    });

    // Handle price break tier selection
    priceBreakRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        console.log('>>> PRICE BREAK CHANGED <<<');
        console.log('Selected radio value:', this.value);
        console.log('data-qty:', this.getAttribute('data-qty'));

        // Update selected state visually
        widget.querySelectorAll('.loop-custom-price-break-item').forEach(item => {
          item.classList.remove('is-selected');
        });
        this.closest('.loop-custom-price-break-item').classList.add('is-selected');

        // Update Shopify button with selected tier - pass the radio directly
        updateShopifyButton(this);
      });
    });

    // Also handle clicks on the wrapper to ensure selection works
    document.querySelectorAll('.loop-custom-price-break-item').forEach(item => {
      item.addEventListener('click', function(e) {
        const radio = this.querySelector('.loop-custom-price-break-radio');
        if (radio && !radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change'));
        }
      });
    });

    // Update native Shopify button with Loop widget info
    // Optional parameter: selectedPriceBreakRadio - if provided, use this instead of querying
    function updateShopifyButton(selectedPriceBreakRadio) {
      const purchaseTypeRadio = widget.querySelector('input[name^="loop-custom-purchase-type"]:checked');
      const selectedFrequency = widget.querySelector('input[name^="loop-custom-frequency"]:checked');

      if (!purchaseTypeRadio || !shopifyAtcButton) return;

      const purchaseType = purchaseTypeRadio.value;
      const isSubscribe = purchaseType === 'subscribe';

      // Get selling plan data
      let sellingPlanId = null;
      let priceAdjustment = 0;
      let deliveryFrequency = '';
      let planName = '';
      let quantity = 1;
      let totalPrice = basePrice;

      if (selectedFrequency && isSubscribe) {
        const selectedOption = selectedFrequency.closest('.loop-custom-frequency-option');
        sellingPlanId = selectedOption.getAttribute('data-selling-plan-id');
        priceAdjustment = parseFloat(selectedOption.getAttribute('data-price-adjustment')) || 0;
        deliveryFrequency = selectedOption.getAttribute('data-delivery-frequency');
        planName = selectedOption.getAttribute('data-plan-name');

        // Calculate price with discount from Loop app
        const discount = priceAdjustment / 100;
        const discountedPrice = basePrice * (1 - discount);

        // Dynamic quantity based on subscription plan (per Loop Support guidance)
        // ONLY applies to MONTH-based plans (not weeks/days)
        // Use data-plan-qty attribute set by Liquid, or fall back to parsing delivery frequency
        // 1-month plan = qty 1, 2-month plan = qty 2, 3-month plan = qty 3
        quantity = 1; // Default to 1
        const planQtyAttr = selectedOption.getAttribute('data-plan-qty');
        if (planQtyAttr) {
          quantity = parseInt(planQtyAttr, 10) || 1;
          console.log('>>> SUBSCRIPTION QUANTITY SET TO', quantity, 'FROM data-plan-qty');
        } else if (deliveryFrequency && deliveryFrequency.toLowerCase().includes('month')) {
          // Fallback: parse from delivery frequency string - ONLY if it contains "month"
          const monthMatch = deliveryFrequency.match(/(\d+)\s*month/i);
          if (monthMatch && monthMatch[1]) {
            const months = parseInt(monthMatch[1], 10);
            if (months >= 1 && months <= 12) {
              quantity = months;
              console.log('>>> SUBSCRIPTION QUANTITY SET TO', months, 'BASED ON MONTHLY DELIVERY:', deliveryFrequency);
            }
          }
        }

        // Calculate total price based on quantity
        totalPrice = discountedPrice * quantity;

        // Update price display in widget
        const priceElement = selectedOption.querySelector('.loop-custom-price');
        if (priceElement) {
          priceElement.textContent = `$${totalPrice.toFixed(2)}`;
        }
      } else if (!isSubscribe) {
        // Handle one-time purchase
        // Use the passed radio if provided, otherwise query for checked one
        const selectedPriceBreak = selectedPriceBreakRadio || widget.querySelector('.loop-custom-price-break-radio:checked');

        console.log('=== ONE TIME PURCHASE DEBUG ===');
        console.log('Found checked price break:', selectedPriceBreak);
        console.log('Was radio passed directly?', !!selectedPriceBreakRadio);
        console.log('data-qty attribute:', selectedPriceBreak ? selectedPriceBreak.getAttribute('data-qty') : 'NULL');

        if (selectedPriceBreak) {
          const qtyAttr = selectedPriceBreak.getAttribute('data-qty');
          const totalAttr = selectedPriceBreak.getAttribute('data-total');
          const originalTotalAttr = selectedPriceBreak.getAttribute('data-original-total');
          const savingsAttr = selectedPriceBreak.getAttribute('data-savings');

          console.log('Raw data-qty value:', qtyAttr);
          console.log('Raw data-total value:', totalAttr);
          console.log('Raw data-savings value:', savingsAttr);

          quantity = parseInt(qtyAttr, 10);
          totalPrice = parseFloat(totalAttr) || basePrice;
          const originalTotal = parseFloat(originalTotalAttr) || totalPrice;
          const savings = parseFloat(savingsAttr) || 0;

          console.log('Parsed quantity:', quantity);
          console.log('Total price:', totalPrice);
          console.log('Savings:', savings);

          // If parsing failed, fallback to 1
          if (isNaN(quantity) || quantity < 1) {
            console.log('WARNING: quantity was NaN or < 1, falling back to 1');
            quantity = 1;
          }

          // Store for button display
          shopifyAtcButton.setAttribute('data-loop-savings', savings.toFixed(2));
          shopifyAtcButton.setAttribute('data-loop-original-total', originalTotal.toFixed(2));

          console.log('Final quantity:', quantity);
          console.log('Final total price:', totalPrice);
        } else {
          console.log('NO PRICE BREAK FOUND - using fallback qty=1');
          // Fallback if no price break exists
          quantity = 1;
          totalPrice = basePrice;
        }
        console.log('=== END DEBUG ===');
      }

      // Update button text to include price and savings
      const buttonText = shopifyAtcButton.querySelector('.button__text, span') || shopifyAtcButton;
      const savings = parseFloat(shopifyAtcButton.getAttribute('data-loop-savings')) || 0;

      if (isSubscribe && sellingPlanId) {
        buttonText.textContent = `Add To Cart | $${totalPrice.toFixed(2)}`;
      } else if (!isSubscribe) {
        // One-time purchase shows total price with savings if applicable
        if (savings > 0) {
          buttonText.textContent = `Add To Cart | $${totalPrice.toFixed(2)} (Save $${savings.toFixed(2)})`;
        } else {
          buttonText.textContent = `Add To Cart | $${totalPrice.toFixed(2)}`;
        }
      } else {
        buttonText.textContent = `Add To Cart | $${basePrice.toFixed(2)}`;
      }

      // Store Loop widget selections as data attributes for cart integration
      shopifyAtcButton.setAttribute('data-loop-purchase-type', purchaseType);
      shopifyAtcButton.setAttribute('data-loop-quantity', quantity);
      shopifyAtcButton.setAttribute('data-loop-price', totalPrice.toFixed(2));

      console.log('>>> BUTTON ATTRIBUTES SET <<<');
      console.log('Purchase Type:', purchaseType);
      console.log('Quantity:', quantity);
      console.log('Price:', totalPrice.toFixed(2));

      if (sellingPlanId && isSubscribe) {
        shopifyAtcButton.setAttribute('data-loop-selling-plan-id', sellingPlanId);
      } else {
        shopifyAtcButton.removeAttribute('data-loop-selling-plan-id');
      }

      // Update Loop's hidden selling_plan input
      if (loopSellingPlanInput) {
        if (isSubscribe && sellingPlanId) {
          loopSellingPlanInput.value = sellingPlanId;
        } else {
          loopSellingPlanInput.value = '';
        }
      }

      // UPDATE VISIBLE QUANTITY SELECTOR - This is the key fix!
      // Find the product form first, then find the quantity input within that form
      // IMPORTANT: Exclude cart drawers, mini-carts, and other non-product-page quantity inputs
      let quantityInput = null;

      if (productForm) {
        // Try to find quantity input within the product form only
        // Exclude inputs that are inside cart-drawer, mini-cart, or have data-line-key (cart items)
        const allQuantityInputs = productForm.querySelectorAll('.quantity-selector__input, input[name="quantity"]');

        for (const input of allQuantityInputs) {
          // Check if this input is NOT inside a cart drawer or mini-cart
          const inCartDrawer = input.closest('cart-drawer, .cart-drawer, mini-cart, .mini-cart, [data-line-key]');
          if (!inCartDrawer) {
            quantityInput = input;
            console.log('>>> FOUND PRODUCT PAGE QUANTITY INPUT (not in cart)');
            break;
          } else {
            console.log('>>> SKIPPING: Found quantity input in cart drawer/mini-cart');
          }
        }
      }

      // Fallback: search for main product quantity input outside cart
      if (!quantityInput) {
        console.log('WARNING: Could not find quantity input in product form, searching for main product input');
        const allInputs = document.querySelectorAll('.quantity-selector__input, input[name="quantity"]');
        for (const input of allInputs) {
          const inCart = input.closest('cart-drawer, .cart-drawer, mini-cart, .mini-cart, [data-line-key]');
          if (!inCart) {
            quantityInput = input;
            console.log('>>> FOUND: Main product quantity input (global search, excluded cart)');
            break;
          }
        }
      }

      if (quantityInput) {
        console.log('>>> FOUND QUANTITY INPUT:', quantityInput.className);
        console.log('>>> UPDATING QUANTITY INPUT TO:', quantity);

        // Update the value
        quantityInput.value = quantity;

        // Trigger input event (some themes use this)
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));

        // Trigger change event
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        console.log('>>> QUANTITY INPUT VALUE AFTER UPDATE:', quantityInput.value);
      } else {
        console.log('WARNING: Could not find quantity input with any selector');
      }

      // Update form quantity and selling plan on submission
      updateProductForm(isSubscribe, sellingPlanId, quantity);
    }

    // Update product form with selling plan and quantity
    function updateProductForm(isSubscribe, sellingPlanId, quantity) {
      if (!shopifyAtcButton) return;

      const productForm = shopifyAtcButton.closest('form');
      if (!productForm) return;

      // Update quantity in form
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.value = quantity;
      }

      // Add/remove selling plan input
      if (isSubscribe && sellingPlanId) {
        let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
        if (!sellingPlanInput) {
          sellingPlanInput = document.createElement('input');
          sellingPlanInput.type = 'hidden';
          sellingPlanInput.name = 'selling_plan';
          productForm.appendChild(sellingPlanInput);
        }
        sellingPlanInput.value = sellingPlanId;
      } else {
        // Remove selling plan if one-time purchase
        const existingSellingPlan = productForm.querySelector('input[name="selling_plan"]');
        if (existingSellingPlan) {
          existingSellingPlan.remove();
        }
      }
    }

    // Style the native Shopify button to match Loop widget theme
    function styleShopifyButton() {
      if (!shopifyAtcButton) return;

      // Apply consistent styling
      shopifyAtcButton.style.width = '100%';
      shopifyAtcButton.style.padding = '1rem 1.5rem';
      shopifyAtcButton.style.borderRadius = '2rem';
      shopifyAtcButton.style.fontSize = '1.125rem';
      shopifyAtcButton.style.fontWeight = '600';
      shopifyAtcButton.style.border = 'none';
      shopifyAtcButton.style.cursor = 'pointer';
      shopifyAtcButton.style.transition = 'all 0.2s ease';
    }

    // Initialize selected states on page load
    const initialPurchaseType = widget.querySelector('input[name^="loop-custom-purchase-type"]:checked');
    if (initialPurchaseType) {
      initialPurchaseType.closest('.loop-custom-type-option').classList.add('is-selected');
    }

    const initialFrequency = widget.querySelector('input[name^="loop-custom-frequency"]:checked');
    if (initialFrequency) {
      initialFrequency.closest('.loop-custom-frequency-option').classList.add('is-selected');
    }

    const initialPriceBreak = widget.querySelector('.loop-custom-price-break-radio:checked');
    if (initialPriceBreak) {
      initialPriceBreak.closest('.loop-custom-price-break-item').classList.add('is-selected');
    }

    // Initialize Shopify button styling and text
    styleShopifyButton();
    updateShopifyButton();

    // Listen for Shopify button clicks to add Loop properties to cart
    if (shopifyAtcButton) {
      const productForm = shopifyAtcButton.closest('form');
      if (productForm) {
        productForm.addEventListener('submit', function(e) {
          const purchaseType = shopifyAtcButton.getAttribute('data-loop-purchase-type');
          const quantity = shopifyAtcButton.getAttribute('data-loop-quantity');
          const sellingPlanId = shopifyAtcButton.getAttribute('data-loop-selling-plan-id');

          // Ensure quantity is set
          const quantityInput = productForm.querySelector('input[name="quantity"]');
          if (quantityInput && quantity) {
            quantityInput.value = quantity;
          }

          // Ensure selling plan is set for subscriptions
          if (purchaseType === 'subscribe' && sellingPlanId) {
            let sellingPlanInput = productForm.querySelector('input[name="selling_plan"]');
            if (!sellingPlanInput) {
              sellingPlanInput = document.createElement('input');
              sellingPlanInput.type = 'hidden';
              sellingPlanInput.name = 'selling_plan';
              productForm.appendChild(sellingPlanInput);
            }
            sellingPlanInput.value = sellingPlanId;
          } else {
            // Remove selling plan for one-time purchase
            const existingSellingPlan = productForm.querySelector('input[name="selling_plan"]');
            if (existingSellingPlan) {
              existingSellingPlan.remove();
            }
          }

          // No need to add properties - selling_plan parameter is sufficient
          // This allows Shopify to properly merge cart items with same variant and plan
        });
      }
    }
  }

})();
